import { Routes } from '@angular/router';

export const VARIANT_ROUTES: Routes = [
  {
    path: 'list',
    loadComponent: async () =>
      (await import('../features/variant/variant.component')).VariantComponent
  },
  {
    path: '**',
    redirectTo: 'list',
    pathMatch: 'full'
  }
];